export default {"src":"/_next/static/media/step2.81091d35.svg","height":56,"width":185,"blurWidth":0,"blurHeight":0};